.recommendations {
  margin-top: 2rem;
}

.list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.item {
  background-color: white;
  border-left: 4px solid var(--color-cta);
  border-radius: 0.3rem;
  margin-top: 1rem;
  padding: 0.5rem 1rem;
}

.public {
  color: var(--color-text);
}

.eyebrow {
  margin: 0 0 0.25rem;
  color: var(--color-link);
  font-size: var(--font-size-small);
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.heading {
  margin: 0 0 0.5rem;
  font-family: var(--font-family-heading);
  font-size: 1.75rem;
  font-weight: 400;
  color: var(--color-primary);
}

.lead {
  margin: 0;
  color: var(--color-text-muted);
  font-size: var(--font-size-small);
}

.publicItem {
  position: relative;
  margin-top: 1rem;
  padding: 2.5rem 1.5rem 1.25rem;
  border-radius: 16px;
  background: var(--color-text-on-primary);
  box-shadow: 0 1px 3px rgba(15, 43, 60, 0.08);
}

.mark {
  position: absolute;
  top: 0.25rem;
  left: 1.25rem;
  font-family: var(--font-family-heading);
  font-size: 4rem;
  line-height: 1;
  color: var(--color-cta);
}

.quote {
  margin: 0 0 1rem;
  white-space: pre-line;
}

.by {
  display: flex;
  flex-wrap: wrap;
  gap: 0.25rem 0.75rem;
  margin: 0;
  font-size: var(--font-size-small);
  color: var(--color-text-muted);
}

.by strong {
  color: var(--color-text);
}
